import React, { useState, useEffect } from "react";
import {
  XCircleIcon,
  DocumentIcon,
  ViewListIcon,
  ChatAlt2Icon,
  UserIcon,
} from "@heroicons/react/solid";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useSelector, connect } from "react-redux";
import { toast } from "react-toastify";

import {
  getAllTags,
  addCustomTag,
  addUsersToTag,
} from "../../../redux/actions/nrp/leaderboardActions";
import ProfileRadialChart from "../profileRadialChart";
import { toAbsoluteUrl } from "../../../services";

// get step data from redux main state
const data = (state) => state.nrpLeaderboard;

const UserProfile = (props) => {
  let { tagsList } = useSelector(data);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [allLabels, setAllLabels] = useState([]);
  const [hoverName, setHoverName] = useState(false);
  const [hoverUniversity, setHoverUniversity] = useState(false);
  const [hoverGrade, setHoverGrade] = useState(false);
  const [hoverSpecilization, setHoverSpecilization] = useState(false);
  const [hoverQualification, setHoverQualification] = useState(false);
  const open = Boolean(anchorEl);
  let {
    name,
    specialization,
    qualification,
    university,
    gradingValue,
    totalScore,
    totalConativeScore,
    totalCompetencyScore,
    percentileRank,
    resume,
    email,
    id,
  } = props.user;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  let handelSubmit = (tagObj) => {
    let { id } = tagObj;
    let { campaign } = props;
    let userId = props.user.id;
    if (userId) {
      props.addUsersToTag([userId], campaign, id);
      setAnchorEl(null);
    } else {
      toast("No users found!", {
        position: "bottom-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }
  };

  useEffect(() => {
    if (allLabels.length === 0) {
      props.getAllTags(props.campaign);
    }
  }, []);
  useEffect(() => {
    if (tagsList) {
      setAllLabels(tagsList);
    }
  }, [tagsList]);
  return (
    <div className={props.custom ? props.custom : ""}>
      <div className="bg-[#007E8C] border-b-2 border-b-[#FFD700B5]">
        <div className="flex justify-end items-start">
          {props.showClose == false ? null : (
            <XCircleIcon
              onClick={props.closeHandler}
              className="w-7 text-[white] cursor-pointer "
              color="white"
            />
          )}
        </div>
        <img
          src={toAbsoluteUrl("/media/nrp/leaderboard/bgProfile.png")}
          style={{ marginTop: "-10px" }}
        />
      </div>
      <div className="bg-[white] rounded-t-lg border-t-2 border-t-[#FFD700B5] flex justify-center items-center mx-auto mt-[-24px] w-9/12 px-4 py-3 shadow-lg ">
        <p
          onMouseOver={() => setHoverName(true)}
          onMouseOut={() => setHoverName(false)}
          className="text-[#007E8C] cursor-pointer text-lg text-center font-extrabold tracking-wider "
        >
          {hoverName
            ? name
            : name && name.length > 20
            ? name.substring(0, 20) + "..."
            : name}
        </p>
      </div>
      <div className="flex flex-row justify-evenly my-4 px-2">
        <div>
          <div className="flex flex-row items-center ">
            <img
              src={toAbsoluteUrl("/media/nrp/leaderboard/university.png")}
              alt="university"
              style={{ width: 35, height: 35 }}
            />
            <div className="ml-2">
              <p className="text-[#2F2E37] font-bold text-sm ">University</p>
              <p
                onMouseOver={() => setHoverUniversity(true)}
                onMouseOut={() => setHoverUniversity(false)}
                className="text-[#333333CC] cursor-pointer font-medium text-sm "
              >
                {hoverUniversity
                  ? university
                  : university && university.length > 20
                  ? university.substring(0, 20) + "..."
                  : university}
              </p>
            </div>
          </div>
          <div className="flex flex-row items-center mt-2 ">
            <img
              src={toAbsoluteUrl("/media/nrp/leaderboard/specialization.png")}
              alt="specialization"
              style={{ width: 35, height: 35 }}
            />
            <div className="ml-2">
              <p className="text-[#2F2E37] font-bold text-sm ">
                Specialization
              </p>
              <p
                onMouseOver={() => setHoverSpecilization(true)}
                onMouseOut={() => setHoverSpecilization(false)}
                className="text-[#333333CC] cursor-pointer font-medium text-sm "
              >
                {hoverSpecilization
                  ? specialization
                  : specialization && specialization.length > 20
                  ? specialization.substring(0, 20) + "..."
                  : specialization}
              </p>
            </div>
          </div>
        </div>
        <div className="ml-1">
          <div className="flex flex-row items-center  ">
            <img
              src={toAbsoluteUrl("/media/nrp/leaderboard/qualifiction.png")}
              alt="Qualification"
              style={{ width: 35, height: 35 }}
            />
            <div className="ml-2">
              <p className="text-[#2F2E37] font-bold text-sm">Qualification</p>

              <p
                onMouseOver={() => setHoverQualification(true)}
                onMouseOut={() => setHoverQualification(false)}
                className="text-[#333333CC] cursor-pointer font-medium text-sm "
              >
                {hoverQualification
                  ? qualification
                  : qualification && qualification.length > 20
                  ? qualification.substring(0, 20) + "..."
                  : qualification}
              </p>
            </div>
          </div>
          <div className="flex flex-row items-center mt-2 ">
            <div>
              <img
                src={toAbsoluteUrl("/media/nrp/leaderboard/grade.png")}
                alt="Grade"
                style={{ width: 35, height: 35 }}
              />
            </div>
            <div className="ml-2">
              <p className="text-[#2F2E37] font-bold text-sm ">Grade</p>

              <p
                onMouseOver={() => setHoverGrade(true)}
                onMouseOut={() => setHoverGrade(false)}
                className="text-[#333333CC] cursor-pointer font-medium text-sm "
              >
                {hoverGrade
                  ? gradingValue
                  : gradingValue && gradingValue.length > 15
                  ? gradingValue.substring(0, 15) + "..."
                  : gradingValue}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-row items-center justify-between mt-4 px-2">
        <div className="ml-[-20px]">
          <ProfileRadialChart
            percentage={[totalScore, totalCompetencyScore, totalConativeScore]}
            labels={["Total", "Competency", "Cognative"]}
            main={percentileRank === "NaN" ? " " : percentileRank}
          />
        </div>
        <div className="w-10/12">
          <div className="bg-[#FFE922] px-2 py-4 justify-center items-center mb-4">
            <p className="text-[#007E8C] font-medium text-center text-xl">
              {totalScore}
            </p>
            <p className="text-[#007E8C] text-xs font-extrabold  text-center">
              Total Score
            </p>
          </div>
          <div className="flex flex-row justify-center  items-center ">
            <div className="bg-[#E87002] rounded-sm px-2 py-2 justify-center items-center">
              <p className="text-[white] font-medium text-lg text-center">
                {totalCompetencyScore}
              </p>
              <p className="text-[white] text-[10px] font-extrabold text-center">
                Competency Score
              </p>
            </div>
            <div className="bg-[#FFC530]  rounded-sm px-2 py-2 justify-center  items-center ml-4">
              <p className="text-[#007E8C] font-medium text-center text-xl">
                {totalConativeScore}
              </p>
              <p className="text-[#007E8C]  text-[10px] font-extrabold text-center">
                Cognitive Score
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="flex flex-row justify-between border-t-2 border-t-[#007E8C] mt-4">
        <button
          onClick={() =>
            props.handelActionMenu("profileResume", { userResume: resume })
          }
          disabled={resume === null ? true : false}
          className={`w-3/12 flex flex-col justify-center items-center  py-1 ${
            resume === null
              ? "text-[grey] hover:text-[gray] bg-[lightgray] "
              : "text-[#007E8C] hover:text-[white] bg-[white] hover:bg-[#007E8C]"
          }  `}
        >
          <DocumentIcon className="w-5 h-5 " />
          <p className="text-sm ">Resume</p>
        </button>
        <button
          onClick={() => props.handelActionMenu("profileFull", { userId: id })}
          className="w-3/12 flex flex-col justify-center items-center  py-1  text-[#007E8C] hover:text-[white] bg-[white] hover:bg-[#007E8C]"
        >
          <UserIcon className="w-5 h-5 " />
          <p className="text-sm ">Full Profile</p>
        </button>
        <button
          onClick={() =>
            props.handelActionMenu("profileMessage", { userEmail: email })
          }
          className="w-3/12 flex flex-col justify-center items-center  py-1  text-[#007E8C] hover:text-[white] bg-[white] hover:bg-[#007E8C]"
        >
          <ChatAlt2Icon className="w-5 h-5 " />
          <p className="text-sm ">Messages</p>
        </button>

        <button
          onClick={handleClick}
          className="w-3/12 flex flex-col justify-center items-center  py-1  text-[#007E8C] hover:text-[white] bg-[white] hover:bg-[#007E8C]"
        >
          <ViewListIcon className="w-5 h-5 " />
          <p className="text-sm ">List</p>
        </button>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          {allLabels.length > 0 ? (
            allLabels.map((item, i) => {
              return (
                <MenuItem key={i} onClick={() => handelSubmit(item)}>
                  {item.name}
                </MenuItem>
              );
            })
          ) : (
            <p
              onClick={handleClose}
              className="cursor-pointer px-2 py-2  text-sm"
            >
              No List Found
            </p>
          )}
        </Menu>
      </div>
    </div>
  );
};

const mapStateToProps = ({ state }) => ({
  state,
});

export default connect(mapStateToProps, {
  getAllTags,
  addCustomTag,
  addUsersToTag,
})(UserProfile);
